import React from 'react';

import { TableComponent } from 'commons/components/Table';
import { IInboundTaskProcessedItem } from 'commons/types';

import S from '../InboundSummary.styles';

import { summaryTableConfig } from './configs';

interface IInboundTaskBinListProps {
  receiveActual: IInboundTaskProcessedItem[];
}

export const InboundTaskReceiveBinList: React.FC<IInboundTaskBinListProps> = ({
  receiveActual,
}) => {
  return (
    <S.ItemContentWrapper container>
      <TableComponent
        data={receiveActual || []}
        config={summaryTableConfig}
        additionalTableConfig={{ bodyFontSize: '12px' }}
      />
    </S.ItemContentWrapper>
  );
};
